import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import clsx from 'clsx';
import { PaginatorItem, PaginatorItemPosition } from './components/paginator-item/PaginatorItem';

export type PaginatorProps = {
  className?: string;
};

export function Paginator(props: PaginatorProps) {
  const { className } = props;

  const previousSidebarTreeNode = useDocsDataModelStore(
    (x) => x.sidebarTree.previousSidebarTreeNode,
  );
  const nextSidebarTreeNode = useDocsDataModelStore((x) => x.sidebarTree.nextSidebarTreeNode);

  if (!previousSidebarTreeNode && !nextSidebarTreeNode) {
    return null;
  }
  return (
    <div className={clsx('flex gap-4', className)}>
      {previousSidebarTreeNode && (
        <PaginatorItem
          className="w-0 flex-1"
          value={previousSidebarTreeNode}
          position={PaginatorItemPosition.Previous}
        />
      )}
      {nextSidebarTreeNode && (
        <PaginatorItem
          className="w-0 flex-1"
          value={nextSidebarTreeNode}
          position={PaginatorItemPosition.Next}
        />
      )}
    </div>
  );
}
